<div class="bar">
    <div class="background-bar"><div class="progress bg-danger" [ngStyle]="barStyle"></div></div>
</div>
<div class="bar-details">
    <div class="bar-range">{{ stakeProgressBarContext.start | bsCurrency: true : 0 : true : '' : currencySymbol }}</div>
    <div class="current-balance">
        {{ stakeProgressBarContext.fillValue | bsCurrency: true : 2 : false : '' : currencySymbol }}
        {{ messages.common.MonthlyStakeLimitRemainingBalance }}
    </div>
    <div class="bar-range right">{{ stakeProgressBarContext.end | bsCurrency: true : 2 : false : '' : currencySymbol }}</div>
</div>
